import { useEffect } from 'react';
import { Box, Paper, Stack, Typography, Divider } from '@mui/material';
import ScienceOutlinedIcon from '@mui/icons-material/ScienceOutlined';
import BloodSetEditor from './BloodsGenerator';
import BloodResultsViewer from './BloodsViewer';
import { makeId } from '../../utils/generateid';

export default function CreateBloodResults({ data, onChange }) {
  useEffect(() => {
    if (!Array.isArray(data) || data.length === 0) return;

    const needsIds = data.some((set) => !set?.id);
    if (!needsIds) return;

    const withIds = data.map((set) =>
      set?.id ? set : { ...set, id: makeId() }
    );

    onChange(withIds);
  }, [data, onChange]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Paper
        elevation={0}
        sx={{
          border: '1px solid #60A5FA',
          borderRadius: 3,
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            px: 2,
            py: 1.25,
            bgcolor: '#dbeafe',
            borderBottom: '1px solid #60A5FA',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <ScienceOutlinedIcon />
          <Box>
            <Typography sx={{ fontWeight: 700 }}>Blood Results</Typography>
            <Typography variant="body2" color="text.secondary">
              Add historical blood results that will appear in the patient EPR.
            </Typography>
          </Box>
        </Box>

        <Box sx={{ p: 2 }}>
          <Stack spacing={3}>
            <Box>
              <Typography sx={{ fontWeight: 700, mb: 0.75 }}>
                Add blood result set
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Use this section to create historic blood result entries for the scenario.
              </Typography>
            </Box>

            <Box>
              <BloodSetEditor
                data={data}
                onChange={(updated) => {
                  onChange(updated);
                }}
              />
            </Box>

            <Divider />

            <Box>
              <Typography sx={{ fontWeight: 700, mb: 0.75 }}>
                Existing entries
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
                Review, update, or remove blood result sets already added.
              </Typography>

              <BloodResultsViewer
                bloodSets={data || []}
                onChange={(updated) => onChange(updated)}
              />
            </Box>
          </Stack>
        </Box>
      </Paper>
    </Box>
  );
}